import { Component, Input } from '@angular/core';

@Component({
  selector: 'ff-ghost-button',
  templateUrl: './ghost-button.component.html',
  styleUrls: ['./ghost-button.component.scss']
})
export class GhostButtonComponent {

    /**
   * Text to be display in the button
   * @internal
   */
  @Input() displayText: string;

  /**
   * Button color style
   */
  @Input() color: string = 'red';

    /**
   * This function will be call when the user click the button,
   * the button will emit the entire html event to be handle
   * in the parent component.
   * @internal
   */
  @Input() onClick: Function;

    /**
   * Allow the user the option to disable the button
   * Default value: false
   * @internal
   */
  @Input() isDisabled: boolean = false;

  constructor() { }

  submit = (event: Event): void => {
    this.onClick(event);
  }

}
